const COPY_ICON_SVG = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.6875 4.5H3.5625C3.41332 4.5 3.27024 4.55926 3.16475 4.66475C3.05926 4.77024 3 4.91332 3 5.0625V15.1875C3 15.3367 3.05926 15.4798 3.16475 15.5852C3.27024 15.6907 3.41332 15.75 3.5625 15.75H11.6875C11.8367 15.75 11.9798 15.6907 12.0852 15.5852C12.1907 15.4798 12.25 15.3367 12.25 15.1875V5.0625C12.25 4.91332 12.1907 4.77024 12.0852 4.66475C11.9798 4.55926 11.8367 4.5 11.6875 4.5ZM11.125 14.625H4.125V5.625H11.125V14.625ZM14.5 2.8125V12.9375C14.5 13.0867 14.4407 13.2298 14.3352 13.3352C14.2298 13.4407 14.0867 13.5 13.9375 13.5C13.7883 13.5 13.6452 13.4407 13.5398 13.3352C13.4343 13.2298 13.375 13.0867 13.375 12.9375V3.375H5.8125C5.66332 3.375 5.52024 3.31574 5.41475 3.21025C5.30926 3.10476 5.25 2.96168 5.25 2.8125C5.25 2.66332 5.30926 2.52024 5.41475 2.41475C5.52024 2.30926 5.66332 2.25 5.8125 2.25H13.9375C14.0867 2.25 14.2298 2.30926 14.3352 2.41475C14.4407 2.52024 14.5 2.66332 14.5 2.8125Z" fill="#777777"/>
</svg>
`;

const CHECK_ICON_SVG = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.35 12.3L4.2 9.15L3.15 10.2L7.35 14.4L15 6.75L13.95 5.7L7.35 12.3Z" fill="#16A34A"/>
</svg>
`;

function getSurveyBrowserHash() {
  const storageKey = 'qrshop_survey_browser_hash';
  let value = '';

  try {
    value = window.localStorage?.getItem(storageKey) || '';

    if (!value) {
      value =
        window.crypto?.randomUUID?.() ||
        `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage?.setItem(storageKey, value);
    }
  } catch (e) {
    value = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  return value;
}

function getTodayString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

function getSurveySubmissionKey(shopId, formId) {
  return `qrshop_survey_submitted_${shopId}_${formId}`;
}

function isSurveyTestMode() {
  return window.QRSHOP_BASE?.surveyTest === true;
}

function isSurveyEmailDisabled() {
  return isSurveyTestMode() && window.QRSHOP_BASE?.surveyDisableEmail === true;
}

function hasSubmittedSurveyToday(shopId, formId) {
  if (isSurveyTestMode()) return false;
  if (!shopId || !formId) return false;

  try {
    return (
      window.localStorage?.getItem(getSurveySubmissionKey(shopId, formId)) ===
      getTodayString()
    );
  } catch (e) {
    return false;
  }
}

function markSurveySubmittedToday(shopId, formId) {
  if (isSurveyTestMode()) return;
  if (!shopId || !formId) return;

  try {
    window.localStorage?.setItem(
      getSurveySubmissionKey(shopId, formId),
      getTodayString()
    );
  } catch (e) {
    // localStorage can be unavailable in private modes.
  }
}

function setSurveyButtonCompleted(button) {
  if (!button) return;

  if (button.classList.contains('quick-menu--survey')) {
    button.innerHTML = '<span>설문<br />완료</span>';
  } else {
    button.textContent = '이미 참여 하셨어요';
  }

  button.dataset.surveyCompleted = '1';
  button.setAttribute('aria-disabled', 'true');
  button.classList.add('survey-button-completed', 'cursor-default');
  button.classList.remove('opacity-80', 'opacity-60', 'pointer-events-none');
  button.disabled = false;
}

function updateSurveyButtonsForSubmission(shopId, formId) {
  document
    .querySelectorAll(
      `[data-survey-open-button][data-survey-shop-id="${shopId}"][data-survey-form-id="${formId}"], [data-survey-quick-link][data-survey-shop-id="${shopId}"][data-survey-form-id="${formId}"]`
    )
    .forEach((button) => setSurveyButtonCompleted(button));
}

function syncSurveySubmittedToday(shopId, formId) {
  markSurveySubmittedToday(shopId, formId);
  updateSurveyButtonsForSubmission(shopId, formId);
}

function initSurveyButtonStates() {
  document
    .querySelectorAll('[data-survey-open-button], [data-survey-quick-link]')
    .forEach((button) => {
      const shopId = Number(button.dataset.surveyShopId || 0);
      const formId = Number(button.dataset.surveyFormId || 0);
      const dailyLimit = button.dataset.surveyDailyLimit === '1';

      if (dailyLimit && hasSubmittedSurveyToday(shopId, formId)) {
        setSurveyButtonCompleted(button);
      }
    });
}

// HTTP 상태 + 서버 메시지 → 설문 상태 확인 에러 코드
function mapSurveyStatusErrorCode(status, message) {
  const m = String(message || '');
  if (status === 403 && /mismatched/i.test(m)) return 'ERR_HTTP_403_MISMATCH';
  if (status === 403 && /inactive/i.test(m)) return 'ERR_HTTP_403_INACTIVE';
  if (status === 403 && /closed/i.test(m)) return 'ERR_HTTP_403_CLOSED';
  if (status === 400 && /survey form/i.test(m)) return 'ERR_HTTP_400_FORM';
  if (status === 400 && /shop/i.test(m)) return 'ERR_HTTP_400_SHOP';
  if (status >= 500) return 'ERR_HTTP_500';
  return `ERR_HTTP_${status}`;
}

async function fetchSurveySubmittedToday(shopId, formId) {
  if (!shopId || !formId) return false;

  const params = new URLSearchParams({
    shop_id: String(shopId),
    survey_form_id: String(formId),
    browser_hash: getSurveyBrowserHash(),
  });

  if (isSurveyTestMode()) {
    params.set('survey_test', '1');
  }

  let res;
  try {
    res = await fetch(`/wp-json/dcraft/v1/survey/status?${params}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });
  } catch (networkError) {
    const err = new Error('Network error');
    err.code = 'ERR_NETWORK';
    throw err;
  }

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data?.message || 'Survey status check failed');
    err.code = mapSurveyStatusErrorCode(res.status, data?.message);
    throw err;
  }

  return Boolean(data?.submitted_today);
}

function getFormValues(form, name) {
  return new FormData(form).getAll(name).map((value) => String(value));
}

function buildSurveyPayload(form) {
  const formData = new FormData(form);
  const answers = {};

  formData.forEach((value, name) => {
    if (!name.startsWith('answers[')) return;

    const match = name.match(/^answers\[([^\]]+)](\[\])?$/);
    if (!match) return;

    const questionId = match[1];

    if (match[2]) {
      answers[questionId] = getFormValues(form, name);
      return;
    }

    answers[questionId] = String(value);
  });

  return {
    shop_id: Number(form.dataset.surveyShopId || 0),
    survey_form_id: Number(form.dataset.surveyFormId || 0),
    started_at: Number(formData.get('survey_started_at') || 0),
    honeypot: String(formData.get('survey_website') || ''),
    browser_hash: getSurveyBrowserHash(),
    survey_test: isSurveyTestMode() ? 1 : 0,
    disabled_email: isSurveyEmailDisabled() ? 1 : 0,
    preview_token: String(form.dataset.surveyPreviewToken || ''),
    staff: getFormValues(form, 'survey_staff[]').length
      ? getFormValues(form, 'survey_staff[]')
      : String(formData.get('survey_staff') || ''),
    answers,
  };
}

function fillSurveyTestDefaults(form) {
  if (!isSurveyTestMode()) return;

  form.querySelectorAll('[data-required-checkbox-group]').forEach((group) => {
    const checked = group.querySelector('input[type="checkbox"]:checked');
    if (checked) return;

    group.querySelector('input[type="checkbox"]:not(:disabled)')?.click();
  });

  const requiredRadios = new Map();

  form
    .querySelectorAll('input[type="radio"][required]')
    .forEach((input) => {
      if (!input.name || requiredRadios.has(input.name)) return;
      requiredRadios.set(input.name, input);
    });

  requiredRadios.forEach((input, name) => {
    if (form.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`)) {
      return;
    }

    form
      .querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:not(:disabled)`)
      ?.click();
  });

  form.querySelectorAll('select[required]').forEach((select) => {
    if (select.value) return;

    const option = Array.from(select.options).find((item) => item.value);
    if (option) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  form
    .querySelectorAll('input[required]:not([type="radio"]), textarea[required]')
    .forEach((input) => {
      if (input.value.trim()) return;

      input.value = '테스트 응답';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

  form
    .querySelectorAll('[data-survey-rating-field]')
    .forEach((field) => updateSurveyRatingStars(field));
}

function fillAllSurveyTestDefaults(root = document) {
  if (!isSurveyTestMode()) return;

  root
    .querySelectorAll('[data-survey-form]')
    .forEach((form) => fillSurveyTestDefaults(form));
}

async function submitSurveyPayload(payload) {
  const res = await fetch('/wp-json/dcraft/v1/survey', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.message || 'Survey submit failed');
  }

  return data;
}

function showSurveyCompletion(form) {
  if (form.closest('.survey-page-form')) {
    return;
  }

  const completionTarget = form.dataset.surveyCompletionTarget || '';
  const completionElement = completionTarget
    ? document.getElementById(completionTarget)
    : null;
  const completionHtml = completionTarget ? completionElement?.innerHTML || '' : '';
  const completionTitle =
    completionElement?.dataset.surveyCompletionTitle || '감사합니다';

  if (completionHtml) {
    window.Alpine?.store('modal')?.show({
      title: completionTitle,
      content: completionHtml,
      type: 'survey-completion',
      size: 'md',
      closeOnBackdrop: false,
    });
    return;
  }

  window.Alpine?.store('modal')?.close?.();
}

function setSurveyFormSubmittedState(form) {
  const wrapper = form.closest('.survey-page-form');
  const section = form.closest('.section--survey');
  const completionTarget = form.dataset.surveyCompletionTarget || '';
  const completionElement = completionTarget
    ? document.getElementById(completionTarget)
    : null;

  form.dataset.submitted = '1';
  section?.classList.add('is-survey-submitted');

  form.querySelectorAll('input, select, textarea, button').forEach((field) => {
    field.disabled = true;
  });

  if (!wrapper || !completionElement) return;

  wrapper.classList.add('is-submitted');

  let pageCompletion = wrapper.querySelector('[data-survey-page-completion]');

  if (!pageCompletion) {
    pageCompletion = document.createElement('div');
    pageCompletion.dataset.surveyPageCompletion = '1';
    pageCompletion.className = 'survey-page-completion';
    wrapper.appendChild(pageCompletion);
  }

  pageCompletion.innerHTML = completionElement.innerHTML;
  pageCompletion.hidden = false;
}

function resetSurveyFormSubmittedState(form) {
  const wrapper = form.closest('.survey-page-form');
  const section = form.closest('.section--survey');
  const pageCompletion = wrapper?.querySelector('[data-survey-page-completion]');

  form.dataset.submitted = '0';

  form.querySelectorAll('input, select, textarea, button').forEach((field) => {
    field.disabled = false;
  });

  wrapper?.classList.remove('is-submitted');
  section?.classList.remove('is-survey-submitted');

  if (pageCompletion) {
    pageCompletion.hidden = true;
    pageCompletion.innerHTML = '';
  }
}

function scrollSurveyPageToTop(form) {
  const section = form.closest('.section--survey-page');
  if (!section) return;

  const top = section.getBoundingClientRect().top + window.scrollY - 16;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  });
}

function updateSurveyRatingStars(field) {
  const checked = field.querySelector('input[type="radio"]:checked');
  const checkedValue = checked ? Number(checked.value) : 0;

  field.querySelectorAll('.survey-rating-star').forEach((label) => {
    const input = label.querySelector('input[type="radio"]');
    const value = input ? Number(input.value) : 0;

    label.classList.toggle('is-active', value > 0 && value <= checkedValue);
  });
}

function getSurveyCouponPayload(button) {
  const card =
    button.closest('[data-survey-coupon-card]') ||
    button
      .closest('.survey-completion, .section--coupon, .modal-content')
      ?.querySelector('[data-survey-coupon-card]');

  if (!card) return null;

  return {
    title: card.dataset.surveyCouponTitle || '감사 할인권',
    text: card.dataset.surveyCouponText || '',
    url: card.dataset.surveyCouponUrl || window.location.href,
  };
}

async function copyTextToClipboard(text) {
  if (!text) {
    throw new Error('Empty clipboard text');
  }

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const copied = document.execCommand('copy');
  textarea.remove();

  if (!copied) {
    throw new Error('Clipboard copy failed');
  }
}

function getSafeDownloadFileName(name) {
  return `${String(name || 'survey-coupon')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, '-')
    .slice(0, 40) || 'survey-coupon'}.png`;
}

function inlineComputedStyles(source, target) {
  if (!(source instanceof Element) || !(target instanceof Element)) {
    return;
  }

  const computed = window.getComputedStyle(source);
  target.style.cssText = Array.from(computed)
    .map((property) => `${property}:${computed.getPropertyValue(property)};`)
    .join('');

  Array.from(source.children).forEach((child, index) => {
    inlineComputedStyles(child, target.children[index]);
  });
}

async function convertImagesToDataUrls(root) {
  const images = Array.from(root.querySelectorAll('img'));

  await Promise.all(
    images.map(async (image) => {
      const src = image.getAttribute('src');
      if (!src || src.startsWith('data:')) return;

      try {
        const response = await fetch(src, { credentials: 'same-origin' });
        const blob = await response.blob();
        const dataUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        image.setAttribute('src', dataUrl);
      } catch (error) {
        image.remove();
      }
    })
  );
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }

      reject(new Error('Canvas blob failed'));
    }, 'image/png');
  });
}

function downloadBlob(blob, fileName) {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}

function getMobilePlatform() {
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  if (/Android/i.test(ua)) {
    return 'android';
  }

  if (
    /iPhone|iPad|iPod/i.test(ua) ||
    (platform === 'MacIntel' && maxTouchPoints > 1)
  ) {
    return 'ios';
  }

  return 'other';
}

async function saveOrShareSurveyCouponImage(button) {
  const card =
    button.closest('[data-survey-coupon-card]') ||
    button
      .closest('.survey-completion, .section--coupon, .modal-content')
      ?.querySelector('[data-survey-coupon-card]');

  if (!card) {
    throw new Error('Coupon card not found');
  }

  const rect = card.getBoundingClientRect();
  const width = Math.ceil(rect.width);
  const clone = card.cloneNode(true);
  const actions = clone.querySelector('.survey-coupon-card__actions');

  if (actions) {
    actions.remove();
  }

  inlineComputedStyles(card, clone);
  clone.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
  clone.style.width = `${width}px`;
  clone.style.height = 'auto';
  clone.style.margin = '0';
  clone.style.boxSizing = 'border-box';

  await convertImagesToDataUrls(clone);

  const holder = document.createElement('div');
  holder.style.position = 'fixed';
  holder.style.left = '-9999px';
  holder.style.top = '0';
  holder.style.width = `${width}px`;
  holder.style.pointerEvents = 'none';
  holder.appendChild(clone);
  document.body.appendChild(holder);

  const height = Math.ceil(clone.getBoundingClientRect().height);
  holder.remove();

  const html = new XMLSerializer().serializeToString(clone);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <foreignObject width="100%" height="100%">
        ${html}
      </foreignObject>
    </svg>
  `;
  const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  const image = await loadImage(svgUrl);
  const canvas = document.createElement('canvas');
  const scale = Math.max(2, window.devicePixelRatio || 1);

  canvas.width = width * scale;
  canvas.height = height * scale;

  const context = canvas.getContext('2d');
  context.scale(scale, scale);
  context.drawImage(image, 0, 0, width, height);

  const fileName = getSafeDownloadFileName(card.dataset.surveyCouponTitle);
  const blob = await canvasToBlob(canvas);
  const file = new File([blob], fileName, { type: 'image/png' });
  const platform = getMobilePlatform();

  if (platform === 'ios' && navigator.canShare?.({ files: [file] }) && navigator.share) {
    try {
      await navigator.share({
        title: card.dataset.surveyCouponTitle || '감사 할인권',
        files: [file],
      });
      return 'shared';
    } catch (error) {
      if (error?.name === 'AbortError') {
        return 'cancelled';
      }
    }
  }

  downloadBlob(blob, fileName);
  return platform === 'android' ? 'android-downloaded' : 'downloaded';
}

function swapIconTemp(iconWrap, ms = 900) {
  if (!iconWrap) return;

  // ✅ 동시에 여러번 클릭해도 깔끔하게: 이전 타이머 정리
  if (iconWrap.__revertTimer) {
    clearTimeout(iconWrap.__revertTimer);
    iconWrap.__revertTimer = null;
  }

  // ✅ 원본 저장(처음 1번만)
  if (!iconWrap.__originalHTML) {
    iconWrap.__originalHTML = iconWrap.innerHTML;
  }

  iconWrap.innerHTML = CHECK_ICON_SVG;

  iconWrap.__revertTimer = setTimeout(() => {
    // 원본으로 복귀 (또는 COPY_ICON_SVG로 강제해도 됨)
    iconWrap.innerHTML = iconWrap.__originalHTML || COPY_ICON_SVG;
    iconWrap.__revertTimer = null;
  }, ms);
}

export function initClick() {
  initSurveyButtonStates();
  fillAllSurveyTestDefaults();

  document.addEventListener('change', (e) => {
    const ratingInput = e.target.closest(
      '[data-survey-rating-field] input[type="radio"]'
    );
    if (!ratingInput) return;

    const field = ratingInput.closest('[data-survey-rating-field]');
    if (!field) return;

    updateSurveyRatingStars(field);
  });

  document.addEventListener('click', async (e) => {
    const surveyButton = e.target.closest('[data-survey-open-button]');
    if (!surveyButton) return;

    e.preventDefault();

    const shopId = Number(surveyButton.dataset.surveyShopId || 0);
    const formId = Number(surveyButton.dataset.surveyFormId || 0);
    const dailyLimit = surveyButton.dataset.surveyDailyLimit === '1';

    if (
      surveyButton.dataset.surveyCompleted === '1' ||
      (dailyLimit && hasSubmittedSurveyToday(shopId, formId))
    ) {
      setSurveyButtonCompleted(surveyButton);
      window.Alpine?.store('toast')?.show(
        '오늘은 이미 설문에 참여하셨습니다.',
        'info'
      );
      return;
    }

    if (surveyButton.disabled) return;

    surveyButton.disabled = true;
    surveyButton.classList.add('opacity-80', 'pointer-events-none');

    if (dailyLimit) {
      try {
        const submittedToday = await fetchSurveySubmittedToday(shopId, formId);

        if (submittedToday) {
          syncSurveySubmittedToday(shopId, formId);
          window.Alpine?.store('toast')?.show(
            '오늘은 이미 설문에 참여하셨습니다.',
            'info'
          );
          return;
        }
      } catch (error) {
        const code = error?.code || 'ERR_UNKNOWN';
        window.Alpine?.store('toast')?.show(
          `설문 상태 확인에 실패했습니다. 잠시 후 다시 시도해 주세요. (${code})`,
          'error'
        );
        return;
      } finally {
        if (surveyButton.dataset.surveyCompleted !== '1') {
          surveyButton.disabled = false;
          surveyButton.classList.remove('opacity-80', 'pointer-events-none');
        }
      }
    }

    setTimeout(() => {
      surveyButton.disabled = false;
      surveyButton.classList.remove('opacity-80', 'pointer-events-none');
    }, 700);

    const target = surveyButton.dataset.surveyTarget || '';
    const content = target ? document.getElementById(target)?.innerHTML || '' : '';

    window.Alpine?.store('modal')?.show({
      title: surveyButton.dataset.surveyTitle || '고객 만족도 조사',
      content,
      type: 'survey',
      size: 'md',
      closeOnBackdrop: false,
    });

    requestAnimationFrame(() => {
      fillAllSurveyTestDefaults(
        document.querySelector('.modal-content') || document
      );
    });
  });

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-single-click]');
    if (!button || button.disabled) return;
    if (button.matches('[data-survey-open-button]')) return;
    if (button.closest('[data-survey-coupon-card]')) return;

    button.disabled = true;
    button.classList.add('opacity-80', 'pointer-events-none');

    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('opacity-80', 'pointer-events-none');
    }, 700);
  });

  document.addEventListener('click', (e) => {
    const item = e.target.closest('[data-copy-item], .wifi-password-item');
    if (!item) return;

    const valueEl = item.querySelector('[data-copy-value], .wifi-password');
    if (!valueEl) return;

    const value = valueEl.textContent.trim();
    const iconWrap = item.querySelector('[data-copy-icon], .wifi-copy-icon');
    const message =
      item.dataset.copyMessage || '클립보드에 복사되었습니다.';

    navigator.clipboard
      .writeText(value)
      .then(() => {
        swapIconTemp(iconWrap, 1000);
        window.Alpine?.store('toast')?.show(message, 'success');
      })
      .catch(() => {
        window.Alpine?.store('toast')?.show('복사에 실패했습니다.', 'error');
      });
  });

  document.addEventListener(
    'click',
    async (e) => {
      const button = e.target.closest(
        '[data-survey-coupon-copy], [data-survey-coupon-share], [data-survey-coupon-open]'
      );
      if (!button) return;

      e.preventDefault();

      if (button.matches('[data-survey-coupon-open]')) {
        if (button.disabled) return;

        button.disabled = true;
        button.classList.add('opacity-80', 'pointer-events-none');

        try {
          const result = await saveOrShareSurveyCouponImage(button);

          if (result === 'cancelled') {
            return;
          }

          const successMessage =
            result === 'shared'
              ? '쿠폰 공유 화면을 열었습니다.'
              : result === 'android-downloaded'
                ? '다운로드 폴더에 쿠폰 이미지가 저장되었습니다.'
                : '쿠폰 이미지를 저장했습니다.';

          window.Alpine?.store('toast')?.show(
            successMessage,
            'success'
          );
        } catch (error) {
          const payload = getSurveyCouponPayload(button);

          if (payload?.url) {
            try {
              await copyTextToClipboard(payload.url);
              window.Alpine?.store('toast')?.show(
                '이미지 저장이 지원되지 않아 쿠폰 링크를 복사했습니다.',
                'warning'
              );
            } catch (copyError) {
              window.Alpine?.store('toast')?.show(
                '쿠폰 저장/공유에 실패했습니다.',
                'error'
              );
            }
          } else {
            window.Alpine?.store('toast')?.show(
              '쿠폰 저장/공유에 실패했습니다.',
              'error'
            );
          }
        } finally {
          button.disabled = false;
          button.classList.remove('opacity-80', 'pointer-events-none');
        }

        return;
      }

      const payload = getSurveyCouponPayload(button);
      if (!payload) return;

      if (button.matches('[data-survey-coupon-share]') && navigator.share) {
        navigator
          .share(payload)
          .then(() => {
            window.Alpine?.store('toast')?.show('공유 화면을 열었습니다.', 'success');
          })
          .catch(() => {});
        return;
      }

      copyTextToClipboard(payload.url)
        .then(() => {
          window.Alpine?.store('toast')?.show('쿠폰 링크가 복사되었습니다.', 'success');
        })
        .catch(() => {
          window.Alpine?.store('toast')?.show('복사에 실패했습니다.', 'error');
        });
    },
    true
  );

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-survey-form]');
    if (!form) return;

    e.preventDefault();

    if (form.dataset.submitting === '1') {
      return;
    }

    fillSurveyTestDefaults(form);

    const invalidCheckboxGroup = Array.from(
      form.querySelectorAll('[data-required-checkbox-group]')
    ).find((group) => !group.querySelector('input[type="checkbox"]:checked'));

    if (invalidCheckboxGroup) {
      invalidCheckboxGroup.querySelector('input[type="checkbox"]')?.focus();
      window.Alpine?.store('toast')?.show('필수 항목을 선택해 주세요.', 'warning');
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const surveyPayload = buildSurveyPayload(form);
    const submitButton = form.querySelector('[data-survey-submit-button]');
    const originalText = submitButton?.textContent || '제출하기';

    form.dataset.submitting = '1';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = '제출 중...';
      submitButton.classList.add('opacity-80', 'pointer-events-none');
    }

    const shopId = Number(form.dataset.surveyShopId || 0);
    const formId = Number(form.dataset.surveyFormId || 0);
    const isPageSurvey = Boolean(form.closest('.survey-page-form'));

    setTimeout(() => {
      if (form.dataset.submitting !== '1') {
        return;
      }

      setSurveyFormSubmittedState(form);

      if (!isPageSurvey) {
        showSurveyCompletion(form);
      } else {
        scrollSurveyPageToTop(form);
      }
    }, 1000);

    submitSurveyPayload(surveyPayload)
      .then(() => {
        syncSurveySubmittedToday(shopId, formId);
        form.reset();
      })
      .catch((error) => {
        const alreadySubmitted = /already submitted/i.test(error.message);
        const message = alreadySubmitted
          ? '오늘은 이미 설문에 참여하셨습니다.'
          : '설문 제출에 실패했습니다.';
        window.Alpine?.store('toast')?.show(message, 'error');
        if (alreadySubmitted) {
          syncSurveySubmittedToday(shopId, formId);
        } else {
          resetSurveyFormSubmittedState(form);
        }
        form.dataset.submitting = '0';

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
          submitButton.classList.remove('opacity-80', 'pointer-events-none');
        }
      });

  });
}
